import React from "react";
import { Button, Card, Col, Container, Row } from "reactstrap";
import { T } from "../../traks";
import { default_currency } from "../../Site";
import store from "../../store";

export const PremiumCustomPackagesInfo = () => {
    const handleUpgradeClick = () => {
        store.dispatch_value('show_cart', true);
    }

    return (
        <Card className="border-radius-10 mt-4 pt-3 pb-3 no-border-color">
            <Container>
                <Row>
                    <Col>
                        <h3 className="fw_700 txt-32px"><T>Build your own package</T></h3>
                    </Col>
                </Row>
                <Row className="d-flex align-items-baseline">
                    <Col lg="10">
                        <span><b className="txt-40px premium-green"><T>18</T> {default_currency}</b></span>
                         <span><b>&nbsp;<T>per participant per month</T></b></span>
                    </Col>
                    <Col>
                        <Button className={`w-100 ad_new_game_button px-4 py-2 btn btn-secondary`} onClick={() => handleUpgradeClick()}>
                            <T>Upgrade</T>
                        </Button>
                    </Col>
                </Row>
            </Container>
        </Card>
    )
}


// WEBPACK FOOTER //
// ./src/c/Premium/PremiumCustomPackagesInfo.js